/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React, { useEffect, useState } from 'react';
import { Card, Col, Modal } from 'react-bootstrap';
import { CustomLoader, RoleCard } from './styles';
import { CheckIcon } from '@heroicons/react/outline';
import toast from 'react-hot-toast';

interface ISwitchRoleCompProps {
  allUserRolesList?: any[];
  onRoleSelect?(role: any): void;
  title?: string;
  current?: string;
  signInToken?: string;
}

export const RoleComp = (props: ISwitchRoleCompProps) => {
  const { allUserRolesList, signInToken, onRoleSelect, title, current } = props;
  const getFirstLetterOfEachWord = (text: any) => {
    try {
      let Rtext = text && text !== '' ? text?.match(/\b\w/g).join('') : '';
      console.log(`Rtext`, Rtext, Rtext.length);
      if (Rtext && Rtext.length > 2) {
        return Rtext.substring(0, 2);
      } else {
        return Rtext.toUpperCase();
      }
    } catch (error) {}
  };

  console.log('current->', current);

  return (
    <Card className="p-3 m-2 shadow">
      <h5 className="mx-3">{title}</h5>
      {allUserRolesList?.map((item: any) => {
        return (
          <RoleCard
            onClick={() => {
              console.log('onrole->');
              if (current === item?.name) {
                toast.error('Please select other Role');
              } else {
                onRoleSelect &&
                  onRoleSelect({
                    roleId: item?.uuid,
                    name: item?.name,
                    token: signInToken,
                  });
              }
            }}
            className="d-flex py-3 px-2 my-3 mx-3 rounded align-items-center justify-content-between"
            style={{
              boxShadow: '0px 0px 5px lightgray',
              borderBottom: '1px solid lightgray',
            }}
          >
            <div className="d-flex align-items-center">
              <div
                className="avatar d-flex align-items-center justify-content-center ms-2 fw-bold rounded me-3"
                style={{ backgroundColor: '#104382' }}
              >
                <span style={{ color: 'white' }}>
                  {getFirstLetterOfEachWord(item?.label)}
                </span>
              </div>
              <span style={{ color: 'black' }}>{item?.label}</span>
            </div>

            {current === item?.name && (
              <div
                style={{
                  width: '30px',
                  marginRight: '30px',
                  color: '#104382',
                  marginBottom: '-30px',
                }}
              >
                <CustomLoader />
                <CheckIcon
                  style={{ position: 'relative', top: '-35px', left: '5px' }}
                />
              </div>
            )}
          </RoleCard>
        );
      })}
    </Card>
  );
};

RoleComp.defaultProps = {
  allUserRolesList: [
    {
      id: 'owner',
      label: 'Owner',
    },
    {
      id: 'applicant',
      label: 'Applicant',
    },
  ],
  title: 'Select your Role',
};
